export const OLD_PLATE_REGEX = /^[A-Z]{3}\d{4}$|^[A-Z]{3}\d{2}[A-Z]\d$/;
export const MERCOSUL_PLATE_REGEX = /^[A-Z]{3}\d[A-Z]\d{2}$/;

export const isPlateFormatValid = (plate) =>
  !!OLD_PLATE_REGEX.test(plate?.toUpperCase()) || !!MERCOSUL_PLATE_REGEX.test(plate?.toUpperCase());
